
import React from 'react';
import { useDispatch, useSelector  } from 'react-redux';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import { IfComp } from '../../../core';

import { getActions } from '../../sagas';
import useDatawinDataModelItem from '../../hooks/useDatawinDataModelItem';
import { getDatawin } from '../../reducers';
import { getObjectList } from '../../reducers/datawin';

import ObjectList from './ObjectList';
import ObjectListStatus from './ObjectListStatus';

const ObjectListPanel = ({onSelectionChanged}) => {

    const classNames = mergeStyleSets({
        ObjectListPanel: {
        },
    });

    const [selection, setSelection] = React.useState();

    const dispatch = useDispatch();
    const dataActions = getActions(dispatch);

    const dataModelItem = useDatawinDataModelItem();
    const objectList = useSelector(state => getObjectList(getDatawin(state.data), dataModelItem ? dataModelItem.id : null));

    const handleObjectClick = (object) => {
        dataActions.setDatawinObject(object);
    }

    const handleSelectionChanged = (selection) => {
        setSelection(selection);
        if (onSelectionChanged) {
            onSelectionChanged(selection);
        }
    }

    return (
        <Stack verticalFill className={classNames.ObjectList} >
            <IfComp cond={dataModelItem}>
                <ObjectList
                    dataModelItem={dataModelItem}
                    objectList={objectList}
                    onObjectClick={handleObjectClick}
                    onSelectionChanged={handleSelectionChanged}
                />
                <IfComp cond={selection}>
                    <ObjectListStatus selection={selection} />
                </IfComp>
            </IfComp>
        </Stack>
    );
}

export default ObjectListPanel;
